module.exports = __webpack_public_path__ + "static/BT-desktop-13-e7c1f11283bf69351be158a2ea4c6d92.jpg";